module.exports = __webpack_public_path__ + "img/topicSustainability.d57c34db.png";